import { clsx } from 'clsx';
import { ChangeEvent, FC, FormEvent } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { Input } from 'atoms/Input';
import { IState } from 'pages/Search/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const SearchInput: FC<{
  state: IState;
  handleSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  clear: () => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
}> = ({
  state,
  handleSearch,
  isOpen,
  handleClose,
  handleOpen,
  handleSubmit,
  clear,
}) => {
  const t = useTranslations();

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    await handleSubmit(e);
    handleClose();
  };

  return (
    <form onSubmit={onSubmit}>
      <Input
        placeholder={t('search.placeholder')}
        value={state.searchValue}
        onFocus={() => {
          if (state.isChanged) {
            handleOpen();
          }
        }}
        onChange={handleSearch}
        classes={{
          input: styles.input,
          root: styles.inputRoot,
        }}
        startAdornment={
          <IconSVG
            type="search"
            className={clsx(styles.icon, styles.iconPrev)}
          />
        }
        endAdornment={
          isOpen && (
            <IconSVG
              type="close"
              className={clsx(styles.icon, styles.iconAfter)}
              onClick={() => {
                handleClose();
                clear();
              }}
            />
          )
        }
      />
    </form>
  );
};
